import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { focusSetApi } from "@/lib/api";

/** Select a flight as a leg's focus. Shared by the day-price plot and the
    options list. Invalidates EVERY surface that reflects the chosen flight —
    the options list (tripPlan), the main itinerary, and the trip total — so the
    main itinerary actually updates. (Previously only tripPlan was invalidated, so
    the itinerary kept showing the old flight; mirrors ChangeFlightDialog.) */
export function useSelectFocusFlight(tripId: string, routeId: string) {
  const queryClient = useQueryClient();
  const [pendingId, setPendingId] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (flightId: string) => focusSetApi.setPreferred(routeId, flightId),
    onMutate: (flightId: string) => setPendingId(flightId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tripPlan", tripId] });
      queryClient.invalidateQueries({ queryKey: ["itinerary", tripId] });
      queryClient.invalidateQueries({ queryKey: ["tripPrice", tripId] });
    },
    onSettled: (_data, _error, flightId) => setPendingId((cur) => (cur === flightId ? null : cur)),
  });

  return { select: (flightId: string) => mutation.mutate(flightId), pendingId };
}
